import { useMutation } from '@tanstack/react-query';

import { prophetTypes } from '../types';
import { replaceMessagesWithUploadedFiles } from '../utils';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const addProphetRule: prophetTypes.AddProphetRule = async (data) => {
  const messagesWithUrls = await replaceMessagesWithUploadedFiles(data.messages, data.page._id);
  return axios.put(`/prophet/rules`, { ...data, messages: messagesWithUrls });
};

type AddProphetRuleOptions = {
  pageId: string;
  config?: MutationConfig<typeof addProphetRule>;
};

export function useAddProphetRule({ config = {}, pageId }: AddProphetRuleOptions) {
  return useMutation({
    ...config,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['prophet-rules', pageId]);
      toasts.loadingToast.success('add-prophet-rule');
      config.onSuccess?.(...args);
    },
    onError: (...args) => {
      toasts.loadingToast.error('add-prophet-rule');
      config.onError?.(...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('add-prophet-rule');
      config.onMutate?.(...args);
    },
    mutationFn: addProphetRule,
  });
}
